import React from 'react';

import ArchiveWidget from '../ArchiveWidget/ArchiveWidget';
import styles from '../css/Archives.module.css';
import { archivesTitle } from '../../../constants/Constants';


class ArchivesList extends React.Component {

  render() {
    const { arhives, typeOfListing, listingId, listingTitle, slug, searchFullText, match } = this.props;
    const tagNameFormattedForTitle = match?.params?.tag?.length > 0 ? ` #${match?.params?.tag}` : '';

    return (
      <div className={styles.content} id="arhive_index_view">
        <div className={styles.container}>
          <h1 className={`${styles.subTitle} h2`}>{`${archivesTitle[typeOfListing]}${tagNameFormattedForTitle}`} {listingTitle}</h1>
          <div className="row-r archives-content">
            {
              arhives.map((arhive, index) => (
                <ArchiveWidget
                  key={index}
                  arhive={arhive}
                  listingId={listingId}
                  searchFullText={searchFullText}
                  slug={slug}
                  typeOfListing={typeOfListing}
                />
              ))
            }
          </div>
        </div>
      </div>
    );
  }
}

export default ArchivesList;
